import { LegalEntityCountry } from '@seapoint/server/enums';
import { ColumnDef } from '@tanstack/react-table';
import { User } from 'lucide-react';
import { Avatar } from '../../../../../design-system/avatar/avatar/avatar';
import { ColumnHeaderWithSorting } from '../../../../../design-system/data-table/column-header-with-sorting';
import { DropdownMenu, DropdownMenuItem } from '../../../../../design-system/dropdown-menu/dropdown-menu';
import { EmployeeView } from '../../../../../types/entity-types';
import { getCountryFlag } from '../../../../../utils/get-country-flag';
import { getBeneficiaryCountryDetails } from '../../../../payments/utils/get-beneficiary-country-details';

export const employeeTableColumnDefinition: ColumnDef<EmployeeView>[] = [
  {
    accessorKey: 'firstName',
    header: ({ column }) => <ColumnHeaderWithSorting column={column} label="Full Name" />,
    cell: ({ row }) => {
      const employee = row.original;
      const fullName = `${employee.firstName} ${employee.lastName}`;

      return (
        <div className="flex items-center gap-3">
          <Avatar name={fullName} size="sm" />
          <span>{fullName}</span>
        </div>
      );
    },
    size: 25,
  },
  {
    accessorKey: 'employeeId',
    header: ({ column }) => <ColumnHeaderWithSorting column={column} label="ID" />,
    cell: ({ row }) => <span>{row.original.employeeId}</span>,
    size: 20,
  },
  {
    accessorKey: 'role',
    header: ({ column }) => <ColumnHeaderWithSorting column={column} label="Role" />,
    cell: ({ row }) => <span>{row.original.role || '-'}</span>,
    size: 25,
  },
  {
    accessorKey: 'country',
    header: ({ column }) => <ColumnHeaderWithSorting column={column} label="Country" />,
    cell: ({ row }) => {
      const country = row.original.country;
      const flag = getCountryFlag(country as unknown as LegalEntityCountry);

      return (
        <div className="flex items-center gap-2">
          {flag && <img src={flag} alt={country} className="h-5 w-5 rounded-full object-cover" />}
          <span>{getBeneficiaryCountryDetails(country).name}</span>
        </div>
      );
    },
    size: 20,
  },
  {
    id: 'actions',
    cell: ({ row, table }) => {
      const employee = row.original;

      const menuItems: DropdownMenuItem[] = [
        {
          id: 'edit',
          label: 'Edit Employee',
          icon: <User size={16} />,
          onClick: () => table.options.meta?.onEditEmployee?.(employee.id),
        },
      ];

      return (
        <div className="flex justify-end">
          <DropdownMenu items={menuItems} />
        </div>
      );
    },
    enableSorting: false,
    enableHiding: false,
    size: 10,
    minSize: 10,
  },
];
